import m from "./../../../dist/es2015/themes/Spirited.js";
export const am5themes_Spirited = m;